import React, { createContext, useEffect, useState } from "react";
import Config from "../config/main";
import { getSwarmPartnerStreamsRequest } from "../helpers/terminalRequests/notifications";
import Zergling from "../helpers/zergling";

export const PartnerStreamsContext = createContext();

export const PartnerStreamsContextProvider = ({ children }) => {
    const [streamsData, setStreamsData] = useState({});

    useEffect(() => {
        let subid;

        (async () => {
            if (Config.main.usePartnerStreams) {
                const response = await Zergling.subscribe(getSwarmPartnerStreamsRequest());
                subid = response.subid;
                setStreamsData(response.data);
            }
        })();

        return () => subid && Zergling.unsubscribe(subid);
    }, []);

    return <PartnerStreamsContext.Provider value={streamsData}>
        {children}
    </PartnerStreamsContext.Provider>
};